/* eslint-disable react/no-unescaped-entities */
import { Alert } from "@mui/material";
import React, { useContext, useState, useEffect } from "react";
import ReactSwitch from "react-switch";
import Kiosk from "../../../assets/images/251.png";
import OwnTablet from "../../../assets/images/tablet.png";
import SwitchContext from "../context";

const FirstPage = () => {
  const {
    openValues,
    toggleSwitch,
    isOutOfStock,
    isUpperLimitReached,
    disable,
  } = useContext(SwitchContext);
  const [warning, setWarning] = useState("");

  const owntablet = openValues.OwnTablet;
  const kiosk = openValues.Kiosk;

  useEffect(() => {
    if (owntablet === 1) {
      disable(["Kiosk"]);
    }
  }, [owntablet]);

  useEffect(() => {
    if (kiosk === 1) {
      disable(["OwnTablet"]);
    }
  }, [kiosk]);

  return (
    <div>
      <div className="mb-3 flex justify-end">
        {warning && (
          <div className="flex justify-center items-center h-[0.1rem] m-5">
            <Alert variant="filled" severity="warning">
              {warning}
            </Alert>
          </div>
        )}
      </div>
      <div>
        <div className="w-full lg:mr-auto">
          <p className="test text-xl md:text-3xl capitalize mb-4 font-medium">
            1. check in kiosk
          </p>
          <div className="pl-0 md:pl-8 text-paragraph">
            <p className="mb-4 leading-relaxed">
              Uzeli's check-in kiosk tablet (Kiozzk) let's both walk-ins and
              appointment clients self check-in at the salon. Check-in tablet is
              a very effective way to build your client database as clients
              enter their name and phone number at check-in. Moreover, clients
              provide text messaging consent at check-in which is required to
              send coupons and promotions to your clients.
            </p>
            <p className="mb-4 leading-relaxed">
              Recommended if you plan to use Uzeli's loyalty or text-message
              marketing functionality and want to build client database with
              minimum effort.
            </p>
          </div>
        </div>
        <div className="block md:flex md:space-x-2">
          <div className="flex-1 text-center">
            <img
              src={Kiosk}
              alt=""
              className="mx-auto mb-4"
              style={{ height: "200px" }}
            />
            <div className="flex flex-row justify-center  w-full items-center my-2 ">
              <h5 className="text-xl w-full justify-end">Buy a Kiozzk</h5>
              <div className="w-[55%] flex justify-center items-center ">
                <ReactSwitch
                  onChange={() => {
                    if (isOutOfStock("Growthzilla Kiozzk")) {
                      setWarning("Currently out of stock");
                      setTimeout(() => {
                        setWarning("");
                      }, 2000);
                      return;
                    } else if (isUpperLimitReached("Growthzilla Kiozzk")) {
                      setWarning("Maximum quantity reached");
                      setTimeout(() => {
                        setWarning("");
                      }, 2000);
                      return;
                    }
                    toggleSwitch("Kiosk");

                    window.GZAnalytics &&
                      window.GZAnalytics.customLog({
                        name: "Cart Items",
                        eventtype: "changed",
                        payload: {
                          checkInKiosk: !openValues.Kiosk,
                        },
                      });
                  }}
                  checked={openValues.Kiosk === 1}
                  checkedIcon={false}
                  uncheckedIcon={false}
                />
              </div>
            </div>
            <p className="text-paragraph">
              The Kiozzk arrives already configured for check-in and is
              supported by Growthzilla. Recommended if you want check-in working
              on day one without sourcing or setting up hardware yourself.
            </p>
          </div>

          <div className="flex-1 text-center">
            <img
              src={OwnTablet}
              alt=""
              className="mx-auto mb-4"
              style={{ height: "200px" }}
            />
            <div className="flex flex-row justify-center  w-full items-center my-2 ">
              <h5 className="text-xl w-full justify-end">
                Bring your own tablet
              </h5>
              <div className="w-[55%] flex justify-center items-center ">
                <ReactSwitch
                  onChange={() => {
                    toggleSwitch("OwnTablet");
                    window.GZAnalytics &&
                      window.GZAnalytics.customLog({
                        name: "Cart Items",
                        eventtype: "changed",
                        payload: {
                          ownTablet: !openValues.OwnTablet,
                        },
                      });
                  }}
                  checked={openValues.OwnTablet === 1}
                  checkedIcon={false}
                  uncheckedIcon={false}
                />
              </div>
            </div>
            <p className="text-paragraph">
              Use a tablet you already own for check-in. There is no hardware
              charge, but it still counts as a device on your plan. Ask your
              Growthzilla sales partner to confirm your device can run check-in
              before you rely on it.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirstPage;
